import { render, staticRenderFns } from "./WagePeriod.vue?vue&type=template&id=4bc98fbb&"
import script from "./WagePeriod.vue?vue&type=script&lang=js&"
export * from "./WagePeriod.vue?vue&type=script&lang=js&"
import style0 from "./WagePeriod.vue?vue&type=style&index=0&id=4bc98fbb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports